<template>
  <transition name="fade">
    <div class="modal" v-if="show">
      <div class="close" v-on:click="close(false)"/>
      <div class="mediaCnt">
        <div class="mediaPreviewCnt" v-on:click="close(false, 'bg')">
          <div class="loading" v-if="loading"></div>
          <div class="mediaPreview" :class="{video: media.type === 'video',
            image: media.type === 'image', png: (media.mimetype === 'image/png'
            && media.alphaPercent >= 10)
            || media.mimetype === 'image/svg+xml',
            gif: media.mimetype === 'image/gif'}">
            <img class="imagePreview" :src="media.imageLg"
              v-on:click.stop="doNothing" v-if="media.type === 'image'">
            <div class="videoPreview youtube" v-if="media.type === 'video'
              && media.mimetype === 'video/youtube'">
              <iframe :src="media.embedUri" frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media;
                gyroscope; picture-in-picture" allowfullscreen></iframe>
            </div>
            <div class="videoPreview" v-else-if="media.type === 'video'">
              <div class="videoProcessing" v-if="media.status === 'processing'">
                <div class="progressCnt" v-on:click.stop="doNothing">
                  <div class="progress processing"
                    v-bind:style="{width: `${media.progress}%`}">
                    <span>Processing {{media.progress}}%</span>
                    <div class="bg"></div>
                  </div>
                </div>
              </div>
              <div class="theVideo" v-else v-on:click.stop="doNothing">
                <VuePlyr ref="video" :options="{ hideControls: false }">
                  <video></video>
                </VuePlyr>
              </div>
            </div>
            <div class="mediaDtlCnt videoPreview" v-else-if="media.type === 'audio'">
              <div class="videoProcessing" v-if="media.status === 'processing'">
                <div class="progressCnt" v-on:click.stop="doNothing">
                  <div class="progress processing"
                    v-bind:style="{width: `${media.progress}%`}">
                    <span>Processing {{media.progress}}%</span>
                    <div class="bg"></div>
                  </div>
                </div>
              </div>
              <div class="theVideo" v-else v-on:click.stop="doNothing">
                <VuePlyr ref="audio" :options="{ hideControls: false }">
                  <audio></audio>
                </VuePlyr>
              </div>
            </div>
            <div class="pdfPreview" v-else-if="media.type === 'pdf'">
              <a class="dfCnt" :href="media.pdf" target="_blank">Download PDF</a>
            </div>
            <div class="htmlPreview" v-on:click.stop="doNothing"
              v-else-if="media.type === 'html' && media.htmlContent">
              <div v-html="media.htmlContent.html"></div>
            </div>
          </div>
        </div>
        <div class="mediaInfo">
          <h4>Media Info</h4>
          <div class="infoItem canEdit">
            <label>Name</label>
            {{media.name}}
            <div class="edit" v-on:click="changeName"></div>
          </div>
          <div class="infoItem canEdit">
            <label>Caption</label>
            {{media.caption}}
            <div class="edit" v-on:click="changeCaption"></div>
          </div>
          <div class="infoItem">
            <label>Media Id</label>
            {{media.id}}
          </div>
          <div class="infoItem">
            <label>Type</label>
            {{media.type.substr(0,1).toUpperCase()}}{{media.type.substr(1)}}
          </div>
          <div class="infoItem">
            <label>Mime Type</label>
            {{media.mimetype}}
          </div>
          <div class="infoItem">
            <label>Date Uploaded</label>
            {{media.uploaded | moment("ddd, D MMM YYYY hh:mm")}}
          </div>
          <div class="infoItem" v-if="media.type === 'video'
            && media.mimetype !== 'video/youtube'">
            <label>Video Size</label>
            <div class="infoItemX">
              1080p
              <span class="yes" v-if="media.vid1080p">YES</span>
              <span class="no" v-if="!media.vid1080p">NO</span>
            </div>
            <div class="infoItemX">
              720p
              <span class="yes" v-if="media.vid720p">YES</span>
              <span class="no" v-if="!media.vid720p">NO</span>
            </div>
            <div class="infoItemX">
              480p
              <span class="yes" v-if="media.vid480p">YES</span>
              <span class="no" v-if="!media.vid480p">NO</span>
            </div>
            <div class="infoItemX">
              360p
              <span class="yes" v-if="media.vid360p">YES</span>
              <span class="no" v-if="!media.vid360p">NO</span>
            </div>
          </div>
          <div class="infoItem" v-if="media.type === 'video'
            && (media.thumb1 || media.thumb2 || media.thumb3 || media.thumb4)">
            <label>Video Thumbnail</label>
            <div class="vidThumbCnt">
              <div class="vidThumb" v-if="media.thumb1"
                :style="{'background-image': `url(${media.thumb1})`}"></div>
              <div class="vidThumb" v-if="media.thumb2"
                :style="{'background-image': `url(${media.thumb2})`}"></div>
              <div class="vidThumb" v-if="media.thumb3"
                :style="{'background-image': `url(${media.thumb3})`}"></div>
              <div class="vidThumb" v-if="media.thumb4"
                :style="{'background-image': `url(${media.thumb4})`}"></div>
            </div>
          </div>
          <div class="infoItem" v-if="media.type === 'image' && media.colors.length > 0
            && !['image/svg+xml', 'image/gif'].includes(media.mimetype)">
            <label>Dominant Color</label>
            <div class="vidThumbCnt">
              <div class="vidThumb" v-for="(c, i) in media.colors" :key="`clr${i}`"
                :style="{'background-color':
                `rgba(${c.red},${c.green},${c.blue},${c.alpha})`}"></div>
            </div>
          </div>
          <div class="editImageCnt">
            <div class="editImage" v-on:click="editMedia"
              v-if="media.type === 'image'">
              <img src="../assets/crop-white.png" class="edit"> Crop Image</div>
            <div class="editImage" v-on:click="rotateImage('right')"
              v-if="media.type === 'image'">
              <img src="../assets/rotate-right.png"> Rotate Right</div>
            <div class="editImage" v-on:click="rotateImage('left')"
              v-if="media.type === 'image'">
              <img src="../assets/rotate-left.png"> Rotate Left</div>
          </div>
        </div>
      </div>
      <div class="cropperCnt" v-if="editing">
        <Cropper :src="media.imageLg" v-on:change="cropperChanged"/>
        <div class="cropperAction">
          <button class="btn btnSecondary"
            v-on:click="editing = false;">Cancel</button>
          <button class="btn btnPrimary" :class="{btnLoading: savingEdit}"
            v-on:click="saveEditing"><span>Save Changes</span></button>
        </div>
      </div>
      <FormInputerShort ref="formInputer"/>
      <Confirmation ref="confirmDialog"/>
      <Snackbar ref="snackbar"/>
    </div>
  </transition>
</template>

<script>
import VuePlyr from 'vue-plyr';
import 'vue-plyr/dist/vue-plyr.css';

import { Cropper } from 'vue-advanced-cropper';
import 'vue-advanced-cropper/dist/style.css';

import FormInputerShort from '@/components/FormInputerShort.vue';
import Confirmation from '@/components/Confirmation.vue';
import Snackbar from '@/components/Snackbar.vue';

export default {
  components: {
    VuePlyr,
    Cropper,
    FormInputerShort,
    Confirmation,
    Snackbar,
  },
  data() {
    return {
      show: false,
      next: null,
      media: null,
      timer: null,
      editing: false,
      loading: false,
      savingEdit: false,
      editCoordinate: null,
    };
  },
  methods: {
    open(m, n) {
      this.media = m;
      this.next = n;
      this.loading = false;
      this.show = true;
      this.getData(m);
    },
    changeCaption() {
      this.$refs.formInputer.open({
        title: 'Media Caption',
        subtitle: 'Write media caption below, media caption will be displayed in front-end if image are set as gallery',
        placeholder: 'Media caption...',
        value: this.media.caption,
        type: 'textarea',
        action: 'Save',
      }, (b, v) => {
        if (!b) return;
        this.media.caption = v;
        this.$http.post(this.$config.uri(`media/${this.media.id}/caption`), {
          caption: v,
        }).then((r) => {
          this.$refs.snackbar.open({ content: 'Caption has been changed' });
        });
      });
    },
    changeName() {
      this.$refs.formInputer.open({
        title: 'Media Name',
        subtitle: 'You can change media name below',
        placeholder: 'Media name...',
        value: this.media.name,
        action: 'Save',
      }, (b, v) => {
        if (!b) return;
        this.media.name = v;
        this.$http.post(this.$config.uri(`media/${this.media.id}/name`), {
          name: v,
        }).then((r) => {
          this.$refs.snackbar.open({ content: 'Media name has been changed' });
        });
      });
    },
    editMedia() { this.editing = true; },
    rotateImage(direction) {
      this.$refs.confirmDialog.open({
        title: 'Rotate Image',
        desc: 'Are you sure you want to rotate this image?',
        action: 'Rotate Image',
      }, (b) => {
        if (!b) return;
        this.loading = true;
        this.$http.get(this.$config.uri(`media/${this.media.id}/rotate/${direction}`)).then((r) => {
          this.$http.get(this.$config.uri(`media/detail/${this.media.id}`)).then((r2) => {
            this.loading = false;
            this.media = r2.data.data;
          });
        });
      });
    },
    saveEditing() {
      this.$refs.confirmDialog.open({
        title: 'Save Croped Image',
        desc: 'Are you sure you want to save croped image? This operation can not be undone.',
        action: 'Crop Image',
      }, (b) => {
        if (!b) return;
        this.savingEdit = true;
        this.$http.post(this.$config.uri(`media/${this.media.id}/crop`), this.editCoordinate).then((r) => {
          this.savingEdit = false;
          this.editing = false;
          this.loading = true;
          this.$http.get(this.$config.uri(`media/detail/${this.media.id}`)).then((r2) => {
            this.loading = false;
            this.media = r2.data.data;
          });
        });
      });
    },
    cropperChanged(e) {
      this.editCoordinate = e.coordinates;
    },
    close(b, type) {
      if (this.timer) clearTimeout(this.timer);
      if (type === 'bg' && this.$refs.video) {
        const v = this.$refs.video.player;
        if (v && v.playing) v.pause();
        else v.play();
        return;
      }
      if (this.$refs.video) this.$refs.video.player.destroy();
      this.show = false;
      if (this.next && typeof this.next === 'function') this.next(b);
    },
    getData(m) {
      const src = [];
      if (m.status === 'processing') {
        this.$http.get(this.$config.uri(`media/detail/${m.id}`)).then((r) => {
          if (r.data.status !== 200) return;
          this.media = r.data.data;
          if (this.media.status === 'processing');
          this.timer = setTimeout(() => {
            this.getData(r.data.data);
          }, 3000);
        });
      } else if (m.type === 'video') {
        if (m.vid1080p) src.push({ src: m.vid1080p, type: 'video/mp4', size: 1080 });
        if (m.vid720p) src.push({ src: m.vid720p, type: 'video/mp4', size: 720 });
        if (m.vid480p) src.push({ src: m.vid480p, type: 'video/mp4', size: 480 });
        if (m.vid360p) src.push({ src: m.vid360p, type: 'video/mp4', size: 360 });
        setTimeout(() => {
          const v = this.$refs.video.player;
          v.source = { type: 'video', title: m.name, sources: src };
          v.play();
        });
      } else if (m.type === 'audio') {
        src.push({ src: m.audio, type: m.mimetype });
        setTimeout(() => {
          const v = this.$refs.audio.player;
          v.source = { type: 'audio', title: m.name, sources: src };
          v.play();
        });
      }
    },
    doNothing() {},
  },
};
</script>

<style lang="scss">
.mediaDtlCnt{
  .plyr--video .plyr__controls{
    position: fixed;
    left: 0; right: 300px; bottom: 0;
    background-color: #000;
    padding: 10px;
    transform: none !important;
    opacity: 1 !important;
    z-index: 991;
  }
  .plyr:fullscreen{
    .plyr__controls{
      right: 0;
    }
  }
}
.cropperCnt{
  .vue-advanced-cropper__background{
    background-color: #000;
    background-image: url(../assets/transparent-bg.png);
    background-size: 240px auto;
    background-position: top left;
  }
}
</style>
<style scoped lang="scss">
.cropperCnt{
  position: fixed;
  left: 0; right: 0; top: 0; bottom: 0;
  background-color: #000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  padding-bottom: 88px;
  .cropperAction{
    position: absolute;
    left: 0; right: 0; bottom: 0;
    height: 68px;
    text-align: right;
    box-sizing: border-box;
    padding: 10px 0 0;
    padding-right: 30px;
    background-color: #222;
    .btn{
      margin-left: 10px;
      &.btnLoading{
        background-color: #151515 !important;
      }
      &.btnSecondary{
        &:hover{
          background-color: transparent;
        }
      }
    }
  }
}
  .dfCnt{
    display: block;
    color: #999;
    border: #999 1px solid;
    padding: 10px 20px;
    border-radius: 3px;
    cursor: pointer;
    &:hover{
      color: #ccc;
      border-color: #ccc;
    }
  }
  .modal{
    position: fixed;
    top: 0; left: 0; right: 0; bottom: 0;
    z-index: 991;
    display: flex;
    align-items: center;
    justify-content: center;
    // background-color: rgba(255,255,255,.8);
    // backdrop-filter: saturate(180%) blur(20px);
    .close{
      position: absolute;
      right: 10px; top: 5px;
      border-radius: 50%;
      width: 40px; height: 40px;
      background-size: 14px auto;
      background-repeat: no-repeat;
      background-position: center;
      cursor: pointer;

      background-color: #444;
      background-image: url(../assets/close-white.png);

      // background-color: #fff;
      // background-image: url(../assets/close.png);
      &:hover{
        background-color: #222;
        // background-color: #eee;
      }
    }
    .mediaCnt{
      display: flex;
      width: 100%;
      .mediaPreviewCnt{
        height: 100vh;
        width: calc(100% - 300px);
        box-sizing: border-box;
        background-color: #222;
        background-color: rgba(0,0,0,.9);
        position: relative;
        .loading{
          position: absolute;
          left: 0; right: 0; bottom: 0; top: 0;
          background-image: url(../assets/loading-2.svg);
          background-position: center;
          background-repeat: no-repeat;
          background-size: 64px auto;
          background-color: rgba(0, 0, 0, .75);
          z-index: 9;
          backdrop-filter: blur(120px) saturate(200%);
        }
        .mediaPreview{
          position: absolute;
          left: 40px; right: 40px; top: 40px; bottom: 40px;
          display: flex;
          align-items: center;
          justify-content: center;
          &.image{
            background-image: url(../assets/transparent-bg.png);
            background-size: 240px auto;
            background-position: top left;
          }
          .htmlPreview{
            position: absolute;
            left: -40px; top: -40px; right: -40px; bottom: -40px;
            overflow-x: hidden;
            overflow-y: auto;
            background-color: #fff;
          }
          &.video{
            left: 0; right: 0; top: 0;
            // background-color: #000;
          }
          .videoPreview{
            width: 100%;
            &.youtube{
              text-align: center;
              iframe{
                width: 100%; height: 540px;
                max-width: 960px;
              }
            }
          }
          .imagePreview{
            max-height: 100%;
            max-width: 100%;
          }
          &.png{
            .imagePreview{
              border: #eee 1px solid;
              max-height: 76%;
              max-width: 76%;
            }
          }
        }
      }
      .mediaInfo{
        width: 300px;
        box-sizing: border-box;
        background-color: #333;
        color: #ddd;
        padding: 20px 30px;
        h4{
          margin: 0 0 20px;
          font-size: 30px;
        }
        .editImageCnt{
          padding-top: 20px;
          .editImage{
            border-radius: 5px;
            display: flex;
            align-items: center;
            cursor: pointer;
            margin-bottom: 20px;
            img{
              height: 26px;
              margin-right: 10px;
              margin-top: -3px;
              margin-left: -4px;
              &.edit{
                height: 20px;
                margin-left: 1px;
                margin-right: 12px;
              }
            }
          }
        }
        .infoItem{
          margin-bottom: 20px;
          font-size: 17px;
          word-break: break-word;
          position: relative;
          &.canEdit{
            padding-right: 24px;
          }
          .edit{
            position: absolute;
            width: 44px; height: 44px;
            right: -21px; top: 10px;
            border-radius: 50%;
            background-image: url(../assets/edit-white.png);
            background-size: 18px auto;
            background-position: center;
            background-repeat: no-repeat;
            transition: all .3s ease;
            cursor: pointer;
            &:hover{
              background-color: rgba(0, 0, 0, .36);
            }
          }
          label{
            font-weight: bold;
            text-transform: uppercase;
            color: #767676;
            font-size: 13px;
            display: block;
            margin: 0 0 4px;
          }
          .infoItemX{
            margin-bottom: 6px;
            display: flex;
            white-space: nowrap;
            span{
              font-weight: 600;
              width: 24px;
              text-align: left;
              margin-left: auto;
              &.yes{
                color: green;
              }
              &.no{
                color: red;
              }
            }
          }
          .vidThumbCnt{
            display: flex;
            padding-left: 6px;
            .vidThumb{
              width: 60px; height: 60px;
              border-radius: 50%;
              background-size: cover;
              margin-left: -15px;
              border: #333 5px solid;
              box-sizing: border-box;
            }
          }
        }
      }
    }
  }

  .progressCnt{
    background-color: #7b7b7b;
    height: 40px;
    border-radius: 50px;
    overflow: hidden;
    width: 50vw;
    max-width: 600px;
    margin: 0 auto;
    .progress{
      height: 100%;
      background-color: #0bad00;
      color: #fff;
      white-space: nowrap;
      font-weight: bold;
      font-size: 20px;
      text-align: center;
      padding: 6px 20px;
      box-sizing: border-box;
      position: relative;
      transition: all .6s ease;
      span{
        position: relative;
        z-index: 2;
      }
      @-webkit-keyframes MOVE-BG {
        from {
          -webkit-transform: translateX(0);
        }
        to {
          -webkit-transform: translateX(46px);
        }
      }
      @keyframes MOVE-BG {
        from {
          transform: translateX(0);
        }
        to {
          transform: translateX(46px);
        }
      }
      .bg{
        position: absolute;
        left: 0; right: 0; top: 0; bottom: 0;
        overflow: hidden;
        z-index: 1;
      }
      &.processing{
        background-color: orange;
      }
      &.processing .bg:before{
        display: block;
        content: "";
        position: absolute;
        left: -46px;
        right: 0;
        top: 0;
        bottom: 0;
        z-index: 1;
        background: -webkit-repeating-linear-gradient(
          145deg,
          rgba(0,0,0,.1) 1px,
          rgba(0,0,0,0) 2px,
          rgba(0,0,0,0) 11px,
          rgba(0,0,0,.1) 12px,
          rgba(0,0,0,.1) 20px
        );
        background: repeating-linear-gradient(
          -55deg,
          rgba(0,0,0,.1) 1px,
          rgba(0,0,0,0) 2px,
          rgba(0,0,0,0) 11px,
          rgba(0,0,0,.1) 12px,
          rgba(0,0,0,.1) 20px
        );
        -webkit-animation-name: MOVE-BG;
        -webkit-animation-duration: .6s;
        -webkit-animation-timing-function: linear;
        -webkit-animation-iteration-count: infinite;
        animation-name: MOVE-BG;
        animation-duration: .6s;
        animation-timing-function: linear;
        animation-iteration-count: infinite;
      }
    }
  }
</style>
